export default function WordGuessIcon() {
  const tiles: [number, number, string, string][] = [
    [0, 0, '#475569', 'W'],
    [1, 0, '#F07C2A', 'O'],
    [2, 0, '#475569', 'R'],
    [0, 1, '#0FA89A', 'D'],
    [1, 1, '#0FA89A', 'S'],
    [2, 1, '#F07C2A', '?'],
    [0, 2, '#0FA89A', 'Y'],
    [1, 2, '#0FA89A', 'A'],
    [2, 2, '#0FA89A', 'Y'],
  ];
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      {tiles.map(([x, y, c, l]) => (
        <g key={`${x}${y}`}>
          <rect x={4 + x * 19.5} y={4 + y * 19.5} width="17" height="17" rx="3.5" fill={c} />
          <text
            x={12.5 + x * 19.5}
            y={17.6 + y * 19.5}
            textAnchor="middle"
            fontSize="12.5"
            fontWeight="900"
            fontFamily="Arial, sans-serif"
            fill="#fff"
          >
            {l}
          </text>
        </g>
      ))}
    </svg>
  );
}
